import React, { useState, useEffect } from "react";
import { TextField, Button, Box } from "@mui/material";

const SoilTypeForm = ({ onSubmit, onCancel, initialData = null }) => {
  const [formData, setFormData] = useState({ name: "", description: "" });

  useEffect(() => {
    if (initialData) {
      setFormData({ ...initialData });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <Box>
      <TextField
        fullWidth
        label="Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        margin="normal"
        size="small"
      />
      <TextField
        fullWidth
        label="Description"
        name="description"
        value={formData.description}
        onChange={handleChange}
        margin="normal"
        multiline
        rows={3}
        size="small"
      />
      <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 2 }}>
        <Button onClick={onCancel} className="vintage-button">Cancel</Button>
        <Button variant="outlined" onClick={handleSubmit} className="vintage-button">
          {initialData ? "Update" : "Create"}
        </Button>
      </Box>
    </Box>
  );
};

export default SoilTypeForm;
